export const ROUTES = {
  root: '/',
  login: '/login',
  confirmBooking: '/c',
  generalReception: '/general-reception',
  receiptBookingExit: '/receipt-booking/exit',
  generalReceptionDeskExit: '/general-reception-desk/exit',
  recordBookingWorkLog: '/record-booking-work-log',
  receiptBooking: '/receipt-booking',
  generalReceptionDesk: '/general-reception-desk',
  spBerthManagement: '/sp/berth-management',
  sp: '/sp',
  mtenants: '/mtenants/:mid',
  notFound: '/not_found',
  forbidden: '/forbidden',
} as const

export const PREVIEW_FILE_ROUTES = {
  normal: '/file-preview',
  driver: '/file-driver-preview',
} as const
